// extracted by mini-css-extract-plugin
export default {"containtCoupon":"InputCoupon_containtCoupon__ueUFl","button":"InputCoupon_button__rDlYq","input":"InputCoupon_input__svYOv"};